import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { createSelector, select, Store } from '@ngrx/store';
import { LoadSlumpProductCatalogAction } from '../../../actions/single-catalogs.actions';
import { getAvailableProducts } from '../../../selectors/products.selectors';
import { filter, take } from 'rxjs/operators';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { RmsSpecificationRemoveRehydrateItem } from '../../../actions/rms-specification.actions';
import { getRmsRehydrate } from '../../../selectors';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/field-select-config.interface';

export const productsAndRehydrate = createSelector(getAvailableProducts, getRmsRehydrate, (state, rehydate) => {
  return {
    state,
    rehydate,
  };
});

const isRehydratation = (
  id: number,
  rehydrateState: {
    [id: number]: {
      [key: string]: any;
    };
  },
  config: FieldSelectConfig,
  fieldName = config.name,
) => {
  if (rehydrateState && config.rehydrate) {
    const rehydratationValue = rehydrateState[id][fieldName];
    return !!rehydratationValue || fieldName in rehydrateState[id];
  } else {
    return false;
  }
};

@Injectable()
export class LoadSlumpCatalog implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent, config: FieldSelectConfig): void {
    this.store
      .pipe(
        select(productsAndRehydrate),
        filter((dataState) => !!value && !!dataState.state.length),
        take(1),
      )
      .subscribe((data) => {
        if (isRehydratation(form.data.id, data.rehydate, config, 'slump')) {
          this.store.dispatch(new RmsSpecificationRemoveRehydrateItem({ id: form.data.id, key: 'slump' }));
        } else {
          const prod = data.state.find((item) => item.comm_product.comm_product.replace(/^0+/, '') === value);
          if (data && prod) {
            const technicalProductCode = _safe(
              () => prod.comm_product.productRecommendation[0].technicalProduct.tech_prod,
            );
            this.store.dispatch(new LoadSlumpProductCatalogAction({ productCode: technicalProductCode }));
          }
        }
      });
  }
}
